// import _ from 'underscore';
import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import lazyLoadView from '@/util/lazyLoadView';

import SideNavSectionView from '../../../common/views/SideNavSectionView';
import loadUserAccessView from '../../loaders/UserAccessLoader';
import loadSelfServiceView from '../../loaders/SelfServiceLoader';
import loadEditOrderFormsView from '../../loaders/EditOrderFormLoader';
import loadReportsView from '../../loaders/ReportsLoader';
import loadLogAProblemView from '../../loaders/LogAProblemLoader';
import loadGeneralView from '../../loaders/GeneralLoader';
import loadSendRemindersView from '../../loaders/SendRemindersLoader';

import tmplAdministrationPage from './AdministrationPage.hbs';
import './AdministrationPage.css';

const AdministrationPage = View.extend({
  template: tmplAdministrationPage,

  className: 'administration-page container-fluid',

  ui: {
    administrationHeader: '.administration-header',
    sections: '.sections-container'
  },

  childViewEvents: {
    reload: 'reloadEditable',
    reassign: 'reassignCRS'
  },

  regions: {
    orderHeader: '@ui.orderHeader',
    sections: '@ui.sections'
  },

  onRender() {
    this.showSideNavSectionView();
  },

  showSideNavSectionView() {
    const model = new Backbone.Model({
      returnLabel: 'Return to Dashboard',
      returnLink: '#dashboard'
    });

    const sidenavSectionView = new SideNavSectionView({
      useNavigationButtons: true,
      activeSectionId: this.options.activeSectionId,
      title: 'Administration',
      model,
      collection: new Backbone.Collection([
        {
          id: 'selfService',
          title: 'Self Service',
          loader: loadSelfServiceView,
          loaderOptions: {},
          isSavable: false,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadSelfServiceView())
        },
        {
          id: 'userAccess',
          title: 'User Access',
          loader: loadUserAccessView,
          loaderOptions: {},
          isSavable: false,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadUserAccessView())
        },
        {
          id: 'general',
          title: 'General',
          loader: loadGeneralView,
          loaderOptions: {},
          isSavable: true,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadGeneralView())
        },
        {
          id: 'reports',
          title: 'Reports',
          loader: loadReportsView,
          loaderOptions: {},
          isSavable: false,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadReportsView())
        },
        {
          id: 'editOrderForms',
          title: 'Edit Order Forms',
          loader: loadEditOrderFormsView,
          isSavable: true,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadEditOrderFormsView())
        },
        {
          id: 'sendReminders',
          title: 'Send Reminders',
          loader: loadSendRemindersView,
          loaderOptions: {},
          isSavable: false,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadSendRemindersView())
        },
        {
          id: 'logProblem',
          title: 'Log a Problem',
          loader: loadLogAProblemView,
          loaderOptions: {},
          isSavable: false,
          hideNavigation: true,
          renderable: true,
          showSubmitButton: false,
          view: lazyLoadView(() => loadLogAProblemView())
        }
      ])
    });

    this.showChildView('sections', sidenavSectionView);
  }
});

export default AdministrationPage;
